import { render, staticRenderFns } from "./luckyWheel.vue?vue&type=template&id=77d28f63"
import script from "./luckyWheel.vue?vue&type=script&lang=js"
export * from "./luckyWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports